import { create } from "zustand";

export interface FormValues {
	applicationType: string;
	firstName: string;
	lastName: string;
	email: string;
	state: string;
	loanAmount: string;
	phone: string;
	loanPurpose: string;
	loanType: string;
	assetType: string;
	purchaseStage: string;
	assetAge: string;
	purchaseFrom: string;
	livingStatus: string;
	employmentStatus: string;
	abnStatus: string;
	gstStatus: string;
	combinedIncome: string;
	creditHistory: string;
	//Commercial Property Finance
	assetCost: string;
	deposit: string;
	propertyCategory: string;
	propertyOption: string;
	// propertyLocation: string;
	propertyAddress: string;
	rentalIncome: string;
	propertyValuation: string;
	assessedValue: string;
	// Working Capital/Cash Flow
	businessAbnStatus: string;
	businessName: string;
	abnYears: string;
	abnMonths: string;
	trusteeName: string;
	abn: string;
	trusteeClassification: string;
	runningFranchise: string;
	franchiseBrand: string;
	postcode: string;
	businessState: string;
	otherAssetType: string;
	financeReason: string;
	otherFinanceReason: string;
	// Additional Info
	propertyOwner: string;
	propertyOwnerOther: string;
}

export const initialFormValues: FormValues = {
	applicationType: "",
	firstName: "",
	lastName: "",
	email: "",
	state: "",
	loanAmount: "",
	phone: "",
	loanPurpose: "",
	loanType: "",
	assetType: "",
	purchaseStage: "",
	assetAge: "",
	purchaseFrom: "",
	livingStatus: "",
	employmentStatus: "",
	abnStatus: "",
	gstStatus: "",
	combinedIncome: "",
	creditHistory: "",
	// Business Loan
	businessAbnStatus: "",
	businessName: "",
	abnYears: "",
	abnMonths: "",
	trusteeName: "",
	abn: "",
	trusteeClassification: "",
	runningFranchise: "",
	franchiseBrand: "",
	postcode: "",
	businessState: "",
	otherAssetType: "",
	financeReason: "",
	otherFinanceReason: "",
	// Additional Info
	propertyOwner: "",
	propertyOwnerOther: "",
	// Commercial Property Finance
	assetCost: "",
	deposit: "",
	propertyCategory: "",
	propertyOption: "",
	// propertyLocation: "",
	propertyAddress: "",
	rentalIncome: "",
	propertyValuation: "",
	assessedValue: "",
};

export interface FormData {
	formValues: FormValues;

	// Initializes formValues
	resetFormValues: () => void;

	// Setter function to update specific fields
	setFormValue: (field: keyof FormValues, value: string) => void;
}

export const useFormData = () =>
	create<FormData>((set) => ({
		formValues: { ...initialFormValues },

		resetFormValues: () =>
			set(() => ({
				formValues: { ...initialFormValues },
			})),

		// Dynamic setter function to update form fields
		setFormValue: (field, value) =>
			set((state) => ({
				formValues: {
					...state.formValues,
					[field]: value,
				},
			})),
	}));
